import { SxProps, Theme } from "@mui/material";
import React, { useState } from "react";
import TextField from "./TextField";
import Show from "../img/Show.svg";

interface Props {
    placeholder?: string;
    value?: string;
    variant?: "contained" | "outlined";
    width?: number | string;
    onChange?: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
    onFocus?: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
    onBlur?: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
    onKeyDown?: React.KeyboardEventHandler<
        HTMLInputElement | HTMLTextAreaElement
    >;
    error?: boolean;
    sx?: SxProps<Theme>;
    fullWidth?: boolean;
    onEnter?: () => void;
}

const PasswordTextField = React.forwardRef((props: Props, ref) => {
    const {
        placeholder,
        value,
        variant,
        onChange,
        onFocus,
        onBlur,
        width,
        onKeyDown,
        error,
        sx,
        fullWidth,
        onEnter,
    } = props;

    const [show, setShow] = useState(false);

    return (
        <TextField
            ref={ref}
            placeholder={placeholder}
            value={value}
            variant={variant}
            onChange={onChange}
            onFocus={onFocus}
            onBlur={onBlur}
            onEnter={onEnter}
            width={width}
            onKeyDown={onKeyDown}
            error={error}
            sx={sx}
            fullWidth={fullWidth}
            icon={Show}
            onClick={() => setShow(!show)}
            type={show ? "text" : "password"}
        />
    );
});

export default PasswordTextField;
